import { QMenuButton } from '@qualio/ui-components';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PageOrientation } from '../../../api/model/document';
import { DocumentOverviewContext, ZoomContext } from './Context';
import { useZoomConfig, ZOOM_CONFIG } from './hooks/useZoomConfig';

export const ZoomDropdown = () => {
  const { t } = useTranslation();
  const zoomContext = useContext(ZoomContext);
  const documentContext = useContext(DocumentOverviewContext);

  const { defaultZoom } = useZoomConfig(
    documentContext?.qualioDocument?.orientation || PageOrientation.Portrait,
  );

  if (!zoomContext) {
    return null;
  }
  const { scale, setScale } = zoomContext;

  const handleOptionChange = (level: string) => {
    if (level === 'fit') {
      setScale(defaultZoom);
    } else {
      setScale(Number.parseFloat(level));
    }
  };

  const zoomOptions = [
    {
      label: t('buttons.fit'),
      id: 'fit',
    },
    ...ZOOM_CONFIG.ZOOM_LEVELS.map((level) => ({
      label: `${Math.round(level * 100)}%`,
      id: level.toString(),
    })),
  ];

  return (
    <QMenuButton
      variant="ghost"
      items={zoomOptions}
      onItemClick={(option) => option && handleOptionChange(option.id)}
      buttonLabel={`${Math.round(scale * 100)}%`}
      data-cy={'doc-zoom-level-selector'}
    />
  );
};
